import React, { Component } from 'react';
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import * as _ from 'lodash';
import * as H from "history";
import PagingRequest from '../../../models/PagingRequest';
import AuditLogComponent from './AuditLog';

interface AuditLogPageProps {
    history: H.History;
}

interface AuditLogPageState {
    pagingRequest: PagingRequest;
}

class AuditLogPage extends Component<AuditLogPageProps & DispatchProps, AuditLogPageState> {
    static displayName = AuditLogPage.name;

    constructor(props: AuditLogPageProps & DispatchProps) {
        super(props);

        this.state = {
            pagingRequest: new PagingRequest("page=-1")
        }
    }

    async componentDidMount() {
        this.setState({ pagingRequest: new PagingRequest(this.props.history.location.search) });
    }

    async componentDidUpdate(prevProps: Readonly<AuditLogPageProps & DispatchProps>, prevState: any): Promise<void> {
        var latest = new PagingRequest(this.props.history.location.search);
        if (!PagingRequest.AreEqual(latest, this.state.pagingRequest)) {
            this.setState({ pagingRequest: latest });
        }
    }

    private pagingRequestChanged = (pagingRequest: PagingRequest) => {
        this.props.history.push(`/dev/auditlogs${pagingRequest.toQueryParams()}`);
    }

    render() {
        return (
            <AuditLogComponent pagingRequest={this.state.pagingRequest} pagingRequestChanged={this.pagingRequestChanged} />
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): AuditLogPageProps => {
        return {
            history: ownProps.history,
        };
    }
)(AuditLogPage)